import React from "react"
import Grid from "../shared/grid"
import {} from "../homepage/hero.style"

import {
  StatListContainer,
  StatListItem,
  StatListNumber,
  StatListPlus,
  OverlayStyle,
} from "./stats.style"

export default function HeroStatistics() {
  return (
    <Grid overlayStyle={OverlayStyle}>
      <StatListContainer>
        <StatListItem>
          <StatListNumber>
            1,100
            <StatListPlus>+</StatListPlus>
          </StatListNumber>
          Live Venues
        </StatListItem>
        <StatListItem>
          <StatListNumber>
            755M<StatListPlus>+</StatListPlus>
          </StatListNumber>
          Sq. Ft. Mapped
        </StatListItem>
        <StatListItem>
          <StatListNumber>
            40<StatListPlus>+</StatListPlus>
          </StatListNumber>
          Countries
        </StatListItem>
      </StatListContainer>
    </Grid>
  )
}
